import { UserRoles } from '@shared/enums/user-roles.enum';

export enum AppRole {
  ADMIN = UserRoles.ROLE_EMPLOYEE_ADMIN,
  MANAGER = UserRoles.ROLE_EMPLOYEE_MANAGER,
  WORKER = UserRoles.ROLE_EMPLOYEE_WORKER
}

export const DEFAULT_PANEL_ROLES: AppRole[] = [AppRole.ADMIN, AppRole.MANAGER, AppRole.WORKER];
export const MANAGEABLE_EMPLOYEE_ROLES: AppRole[] = DEFAULT_PANEL_ROLES;
